<template>
  <section class="mb-3">
    <table class="b2b-table b2b-table--narrow b2b-table--borderless max-w-sm">
      <tbody>
        <tr>
          <th scope="row" v-html="legendName"></th>
          <td qaid="view-user-name" v-html="items.name"></td>
        </tr>
        <tr>
          <th scope="row" v-html="legendEmailAddress"></th>
          <td qaid="view-user-email" v-html="items.emailAddress"></td>
        </tr>
        <tr>
          <th scope="row" v-html="legendStoreName"></th>
          <td qaid="view-user-store" v-html="items.businessUnit"></td>
        </tr>
        <tr>
          <th scope="row" v-html="legendUserRole"></th>
          <td qaid="view-user-role" v-html="items.role.name"></td>
        </tr>
        <tr>
          <th scope="row" v-html="legendUserStatus"></th>
          <td qaid="view-user-userstatus" v-html="userStatusText()"></td>
        </tr>
      </tbody>
    </table>
    <div class="buttons my-4">
      <trek-link
        id="editUserButton"
        button
        primary
        :href="`${editButtonRef}?user=${items.uid}`"
        qaid="edit-user-button"
      >
        <span v-html="labelEditUser"></span>
      </trek-link>
    </div>
  </section>
</template>

<script>
import TrekLink from '@/components/TrekLink';

export default {
  components: {TrekLink},
  props: {
    legendName: {
      type: String,
      default: '',
    },
    legendStoreName: {
      type: String,
      default: '',
    },
    legendEmailAddress: {
      type: String,
      default: '',
    },
    legendUserStatus: {
      type: String,
      default: '',
    },
    legendUserRole: {
      type: String,
      default: '',
    },
    labelEditUser: {
      type: String,
      default: '',
    },
    labelResetPassword: {
      type: String,
      default: '',
    },
    editButtonRef: {
      type: String,
      default: '',
    },
    textActive: {
      type: String,
      default: '',
    },
    textInactive: {
      type: String,
      default: '',
    },
    items: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    userStatusText() {
      return this.items.userStatus ? this.textActive : this.textInactive;
    },
  },
};
</script>
